<template>
  <div class="shipment-tag">
    <div class="shipment-tag-reminder">{{ reminder }}</div>
    <div class="shipment-tag-inner">
      <component :is="tagName" />
    </div>
  </div>
</template>

<script>
  import Correios from './shipment-tags/Correios.vue';
  import CorreiosWithQrCode from './shipment-tags/CorreiosWithQrCode.vue';
  import JadlogSmartLabelSimple from './shipment-tags/JadlogSmartLabelSimple.vue';
  import JadlogSmartLabel from './shipment-tags/JadlogSmartLabel.vue';
  import JadlogSmartLabelWithQrCode from './shipment-tags/JadlogSmartLabelWithQrCode.vue';
  import LATAMCargo from './shipment-tags/LatamCargo.vue';
  import AzulCargoExpress from './shipment-tags/AzulCargo.vue';
  import Buslog from './shipment-tags/Buslog.vue';
  import LoggiExpress from './shipment-tags/LoggiExpress.vue';
  import JET from './shipment-tags/JET.vue';

  import ShippingDefinitions from './../../ShippingDefinitions';
  import { ORDER_MODALITIES } from 'commons/js/enums/orders';

  export default {
    mixins: [
      ShippingDefinitions,
    ],

    components: {
      Correios,
      CorreiosWithQrCode,
      JadlogSmartLabelSimple,
      JadlogSmartLabel,
      JadlogSmartLabelWithQrCode,
      LATAMCargo,
      AzulCargoExpress,
	    Buslog,
      LoggiExpress,
      JET,
    },

    props: {
      id: {
        type: String,
        required: false
      },
      generateTag: {
        type: Object,
        required: false
      },
      generateVolume: {
        type: Object,
        required: false
      },
      volumeIndex: {
        type: Number,
        required: false
      },
      isMelhorPontoQrCodeTester: {
        type: Boolean,
        required: false
      },
    },

    computed: {
      companyId() {
        return String(this.generateTag.service.company.id || '');
      },
      mpCode() {
        return this.generateVolume.mpCode
      },
      protocol() {
        return this.generateTag.protocol;
      },
      shippingCompany() {
        return this.generateTag.service.company.name;
      },
      shippingServiceName() {
        return this.generateTag.service.name;
      },
      shippingServiceIcon() {
        return this.generateTag.service.type;
      },
      serviceId() {
        return String(this.generateTag.service_id || '');
      },
      contract() {
        return this.generateTag.contract;
      },
      serviceCode() {
        return this.generateTag.service_code;
      },
      agency() {
        return this.generateTag.agency ? this.generateTag.agency.name : '';
      },
      agencyCity() {
        return this.generateTag.agency ? this.generateTag.agency.address.city : '';
      },
      authorizationCode() {
        return String(this.generateTag.authorization_code || '');
      },
      tracking() {
        return String(this.generateTag.tracking || '');
      },
      selfTracking() {
        return this.generateTag.self_tracking;
      },
      packageWeight() {
        return String(this.generateTag.weight || this.generateVolume.weight || '')
      },
      packageWidth() {
        return String(this.generateTag.width || this.generateVolume.width || '')
      },
      packageHeight() {
        return String(this.generateTag.height || this.generateVolume.height || '')
      },
      packageLength() {
        return String(this.generateTag.length || this.generateVolume.length || '')
      },
      packagediameter() {
        return String(this.generateTag.diameter || this.generateVolume.diameter || '')
      },
      packageFormat() {
        return this.generateTag.format;
      },
      fromName() {
        return this.generateTag.from ? this.generateTag.from.name : '';
      },
      fromPhone() {
        return this.generateTag.from ? this.generateTag.from.phone : '';
      },
      fromAddress() {
        return this.generateTag.from ? this.generateTag.from.address : '';
      },
      fromLocationNumber() {
        return this.generateTag.from ? String(this.generateTag.from.location_number || '') : '';
      },
      fromComplement() {
        return this.generateTag.from ? this.generateTag.from.complement : '';
      },
      fromDistrict() {
        return this.generateTag.from ? this.generateTag.from.district : '';
      },
      fromCity() {
        return this.generateTag.from ? this.generateTag.from.city : '';
      },
      fromStateAbbr() {
        return this.generateTag.from ? this.generateTag.from.state_abbr : '';
      },
      fromCountryId() {
        return this.generateTag.from ? this.generateTag.from.country_id : '';
      },
      fromPostalCode() {
        return this.generateTag.from ? String(this.generateTag.from.postal_code || '') : '';
      },
      toName() {
        return this.generateTag.to ? this.generateTag.to.name : '';
      },
      toPhone() {
        return this.generateTag.to ? this.generateTag.to.phone : '';
      },
      toAddress() {
        return this.generateTag.to ? this.generateTag.to.address : '';
      },
      toLocationNumber() {
        return this.generateTag.to ? String(this.generateTag.to.location_number || '') : '';
      },
      toComplement() {
        return this.generateTag.to ? this.generateTag.to.complement : '';
      },
      toDistrict() {
        return this.generateTag.to ? this.generateTag.to.district : '';
      },
      toCity() {
        return this.generateTag.to ? this.generateTag.to.city : '';
      },
      toStateAbbr() {
        return this.generateTag.to ? this.generateTag.to.state_abbr : '';
      },
      toCountryId() {
        return this.generateTag.to ? this.generateTag.to.country_id : '';
      },
      toPostalCode() {
        return this.generateTag.to ? String(this.generateTag.to.postal_code || '') : '';
      },
      toNote() {
        return this.generateTag.to ? this.generateTag.to.note : '';
      },
      toLatitude() {
        return this.generateTag.to ? String(this.generateTag.to.latitude || '') : '';
      },
      toLongitude() {
        return this.generateTag.to ? String(this.generateTag.to.longitude || '') : '';
      },
      invoiceNumber() {
        return this.generateTag.invoice ? String(this.generateTag.invoice.number || '') : '';
      },
      receipt() {
        return this.generateTag.receipt ? '1' : '0';
      },
      ownHand() {
        return this.generateTag.own_hand ? '1' : '0';
      },
      collect() {
        return this.generateTag.collect ? '1' : '0';
      },
      insuranceValue() {
        return String(this.generateTag.insurance_value);
      },
      reminder() {
        return this.generateTag.reminder;
      },
      createdAt() {
        return this.generateTag.created_at;
      },
      generatedAt() {
        return this.generateTag.generated_at;
      },
      additionalInfo() {
        return this.generateTag.additional_info;
      },
      volumeTotal() {
        return this.generateTag.volumes.length;
      },
      volume() {
        if (this.additionalInfo && this.additionalInfo.volume && this.additionalInfo.volume.length) {
          return this.additionalInfo.volume[this.volumeIndex || 0];
        }
        return null;
      },
      reverse() {
        return this.generateTag.reverse;
      },
      tagName() {
       const id = this.companyId;

        if (this.isCorreios(id)) {
          return 'CorreiosWithQrCode';
        }

        if (this.isJadlog(id)) {
          return 'JadlogSmartLabelWithQrCode';
        }

        if (this.isAzulCargoExpress(id)) {
          return 'AzulCargoExpress';
        }

        if (this.isLATAMCargo(id)) {
          return 'LATAMCargo';
        }

        if (this.isBuslog(id)) {
          return 'Buslog';
        }

        if (this.isLoggi(id)) {
          return 'LoggiExpress';
        }

        if (this.isJET(id)) {
          return 'JET';
        }
      },
      tag() {
        let website = String(this.website || 'melhorenvio.com').toLowerCase();

        let companyIcon = '/images/shipment/melhorenvio/logo.svg';

        let tag = {
          id: this.id,
          protocol: this.protocol,
          contract: this.contract || '',
          serviceCode: this.serviceCode || '',
          agency: this.agency || '',
          agencyCity: this.agencyCity || '',
          authorizationCode: this.authorizationCode || '',
          tracking: this.tracking || 'MELHOR ENVIO',
          selfTracking: this.selfTracking || 'MELHOR ENVIO',
          website: website,
          package: {
            format: this.packageFormat || ''
          },
          from: {
            name: this.fromName || 'NOME DO REMETENTE',
            phone: this.fromPhone || '',
            address: this.fromAddress || 'ENDEREÇO',
            locationNumber: this.fromLocationNumber || 'NÚMERO',
            complement: this.fromComplement || '',
            district: this.fromDistrict || 'BAIRRO',
            city: this.fromCity || 'CIDADE',
            stateAbbr: this.fromStateAbbr || 'UF',
            countryId: this.fromCountryId || 'BR',
            postalCode: '00000000'
          },
          to: {
            name: this.toName || 'NOME DO DESTINATÁRIO',
            phone: this.toPhone || '',
            address: this.toAddress || 'ENDEREÇO',
            locationNumber: this.toLocationNumber || 'NÚMERO',
            complement: this.toComplement || '',
            district: this.toDistrict || 'BAIRRO',
            city: this.toCity || 'CIDADE',
            stateAbbr: this.toStateAbbr || 'UF',
            countryId: this.toCountryId || 'BR',
            postalCode: '00000000',
            note: this.toNote || '',
            latitude: this.toLatitude || '',
            longitude: this.toLongitude || '',
          },
          invoice: {
            number: this.invoiceNumber
          },
          receipt: Boolean(Number(this.receipt)),
          ownHand: Boolean(Number(this.ownHand)),
          collect: Boolean(Number(this.collect)),
          reminder: String(this.reminder || '').toUpperCase(),
          created_at: this.createdAt ? String(this.createdAt) : null,
          generatedAt: this.generatedAt ? String(this.generatedAt) : null,
          companyIcon: companyIcon,
          serviceName: this.shippingServiceName,
          serviceIcon: this.shippingServiceIcon,
          name: this.tagName,
          additionalInfo: this.additionalInfo,
          volumeIndex: this.volumeIndex,
          volumeTotal: this.volumeTotal
        };

        function leftPad(value, length = 8, chr = '0') {
          while (value.length < length) {
            value = chr + value;
          }
          return value;
        }

        if (this.fromPostalCode) {
          tag.from.postalCode = leftPad(String(this.fromPostalCode).replace(/\D/g, ''));
        }

        if (this.toPostalCode) {
          tag.to.postalCode = leftPad(String(this.toPostalCode).replace(/\D/g, ''));
        }

        let serviceId = Number(this.serviceId);

        tag.serviceId = isFinite(serviceId) && !isNaN(serviceId)
          ? serviceId : 0;

        let insuranceValue = Number(this.insuranceValue);

        tag.insuranceValue = isFinite(insuranceValue) && !isNaN(insuranceValue)
          ? insuranceValue : 0;

        let packageWeight = Number(this.packageWeight);

        tag.package.weight = isFinite(packageWeight) && !isNaN(packageWeight)
          ? packageWeight : 0;

        let packageWidth = Number(this.packageWidth);

        tag.package.width = isFinite(packageWidth) && !isNaN(packageWidth)
          ? packageWidth : 0;

        let packageHeight = Number(this.packageHeight);

        tag.package.height = isFinite(packageHeight) && !isNaN(packageHeight)
          ? packageHeight : 0;

        let packageLength = Number(this.packageLength);

        tag.package.length = isFinite(packageLength) && !isNaN(packageLength)
          ? packageLength : 0;

        let packageDiameter = Number(this.packageDiameter);

        tag.package.diameter = isFinite(packageDiameter) && !isNaN(packageDiameter)
          ? packageDiameter : 0;

        return tag;
      },
      isReverseLogistic() {
        return this.reverse === ORDER_MODALITIES.REVERSE_LOGISTIC;
      },
      serviceName() {
        return this.getServiceName(this.shippingServiceName);
      },
    },

    methods: {
      getServiceName(serviceName) {
        return this.isReverseLogistic ? `${serviceName} Reverso` : serviceName;
      },
    }
  }
</script>

<style lang="stylus" scoped>
.shipment-tag
  width 375px
  max-width 100%
  padding 5px

  >>> *
    font-family Arial, serif
    font-size 10pt

  .shipment-tag-reminder
    height 15px
    text-align center
    text-transform uppercase
    display block

  .shipment-tag-inner
    height 515px
    color black
    background white
    border 2px solid #000
    overflow hidden

    .shipment-tag-to
      .line
        padding-right 60px

    >>> .line
      min-height 15px
      white-space normal
      margin-bottom 4px
      line-height 14px
      text-align left
</style>

<style lang="stylus">
.barcode
  width auto
  height auto
  display block
  margin-left auto
  margin-right auto

.barcode-small
  height 40px
</style>
